// extracted by mini-css-extract-plugin
module.exports = {"zonesMenu":"styles_zonesMenu__1JChe"};